import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  ChevronFirst, ChevronLast, MoreVertical,
  Home, Pill, ClipboardPlus,
  Calendar1, Stethoscope, LifeBuoy, Settings, BookOpen, NotebookPen, LibraryBig,
  Menu,
  X
} from "lucide-react";
import { Link } from 'react-router-dom';
import { getUserProfile } from '../../api/userProfileApi';


const SidebarContext = createContext();

export default function Sidebar({ expanded, setExpanded, children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const defaultItems = (
    <>
      <SidebarItem icon={<Home size={20} />} text="Home" to="/dashboard" />
      <SidebarItem icon={<Calendar1 size={20} />} text="Calendar" to="/appointments" />
      <SidebarItem icon={<Pill size={20} />} text="Pharmacy" to="/medications" />
      <SidebarItem icon={<Stethoscope size={20} />} text="My Care Team" to="/careteam" />
      <SidebarItem icon={<ClipboardPlus size={20} />} text="My Health Info" to="/medicalhistory" />
      <SidebarItem icon={<NotebookPen size={20} />} text="Notes" to="/notes" />
      <SidebarItem icon={<BookOpen size={20} />} text="Library" to="/library" />
      <SidebarItem icon={<LibraryBig size={20} />} text="Results" to="/results" />
      <hr className="my-3 border-gray-600" />
      <SidebarItem icon={<Settings size={20} />} text="Settings" to="/settings" />
      <SidebarItem icon={<LifeBuoy size={20} />} text="Help" to="/help" />

    </>
  );

  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        return;
      }
      const data = await getUserProfile(userId);
      setProfile(data);
    };
    fetchProfile();
  }, []);
  return (
    <>
      <aside className={`hidden md:block fixed top-0 left-0 h-screen z-50 transition-all duration-300 ${expanded ? 'w-56' : 'w-16'}`}>
        <nav className="flex flex-col h-full bg-[#04395b] border-r shadow-sm transition-all duration-300">
          {/* Top section */}
          <div className="flex items-center justify-between p-4 pb-2">
            <img
              src="/png_logo.png"
              className={`overflow-hidden transition-all bg-white rounded-full ${expanded ? "w-32" : "w-0"}`}
              alt="Profile Iimage"
            />
            <button
              onClick={() => setExpanded(curr => !curr)}
              className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100"
            >
              {expanded ? <ChevronFirst /> : <ChevronLast />}
            </button>
          </div>

          {/* Nav Items */}
          <SidebarContext.Provider value={{ expanded }}>
            <ul className="flex-1 px-3">{children || defaultItems}</ul>
          </SidebarContext.Provider>

          {/* Bottom section */}
          <div className="flex p-3 mt-auto border-t border-gray-700">
            <img src="/img_8916.png" className="w-10 h-10 rounded-md" />
            <div className={`flex justify-between items-center overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"}`}>
              <div className="leading-4">
                <a href="/profile">
                  <h4 className="font-semibold text-white">{profile && profile.full_name}</h4>
                </a>
              </div>
              {/* for now, go to settings; maybe later make it so that you can edit profile right here or log out */}
              <a href="/settings">
                <MoreVertical size={20} className="text-white" />
              </a>
            </div>
          </div>
        </nav>
      </aside>

      {/* Mobile Hamburger */}
      <div className="flex md:hidden p-4 bg-[#04395b] text-white items-center justify-between">
        <button onClick={() => setMobileMenuOpen(true)}>
          <Menu size={28} />
        </button>
        <img src="/png_logo.png" alt="Logo" className="w-10 h-10 rounded-full bg-white" />
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <SidebarContext.Provider value={{ expanded: true }}>
          <div className="fixed inset-0 z-50 bg-[#04395b] text-white flex flex-col p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold">Menu</h2>
              <button onClick={() => setMobileMenuOpen(false)}>
                <X size={28} />
              </button>
            </div>
            <ul className="flex-1 space-y-4">
              {children || defaultItems}
            </ul>
          </div>
        </SidebarContext.Provider>
      )}


    </>
  );
}

export function SidebarItem({ icon, text, to, active, alert }) {
  const { expanded } = useContext(SidebarContext);
  return (
    <li>
      <Link
        to={to}
        className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group
        ${active ? "bg-gradient-to-tr from-indigo-200 to-indigo-100 text-indigo-800" : "hover:bg-indigo-50 hover:text-black text-white font-bold"}`}
      >
        {icon}
        <span className={`overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"}`}>
          {text}
        </span>
        {alert && (
          <div className={`absolute right-2 w-2 h-2 rounded-full bg-indigo-400 ${expanded ? "" : "top-2"}`} />
        )}
        {!expanded && (
          <div
            className="absolute invisible px-2 py-1 ml-6 text-sm text-indigo-800 transition-all -translate-x-3 bg-indigo-100 rounded-md left-full opacity-20 group-hover:visible group-hover:opacity-100 group-hover:translate-x-0"
          >
            {text}
          </div>
        )}
      </Link>
    </li>
  );
}
